<template>
  <div class="sidebar">
    <nav class="sidebar-nav">
      <ul class="nav">
        <li class="nav-item">
          <router-link :to="'/dashboard'" class="nav-link">
            <i class="fa fa-dashboard"></i> Overview <!--<span class="badge badge-info">NEW</span>-->
          </router-link>
        </li>
        <li class="nav-title">
          Pages
        </li>
        <li class="nav-item">
          <router-link :to="'/data'" class="nav-link">
            <i class="fa fa-database"></i> Data
          </router-link>
        </li>
        <li class="nav-item">
          <router-link :to="'/graphs'" class="nav-link">
            <i class="fa fa-pie-chart"></i> Graphs
          </router-link>
        </li>
        <!--
        <li class="nav-item">
          <router-link :to="'/reporting'" class="nav-link" exact>
            <i class="fa fa-percent"></i> Reporting
          </router-link>
        </li>
        -->
        <li class="divider"></li>
        <li class="nav-item">
          <router-link :to="'/support'" class="nav-link" exact>
            <i class="fa fa-support"></i> Support
          </router-link>
        </li>
      </ul>
      <div class="company-logo" v-if="$session.user.company">
        <img v-if="$session.user.company.logo" :src="$session.user.company.logo" />
        <span v-else>
          {{$session.user.company.name}}
        </span>
      </div>
    </nav>
  </div>
</template>
<script>

export default {
  name: 'sidebar',
  methods: {
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('open')
    }
  }
}
</script>

<style lang="scss">
  .sidebar {
    .nav {
      .nav-item {
        .nav-link {
          cursor:pointer;
          i {
            color: #fff;
          }
        }
      }
    }
  }
  .sidebar-nav {
    position: relative;
    .company-logo {
      position: absolute;
      left: 0;
      bottom: 0;
      height: 35px;
      text-align: center;
      width: 100%;
      img {
        max-width: 100%;
        max-height: 35px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Sidebar.vue?2b022365